<!-- =========================================================================================
    File Name: Admin.vue
    Description: Admin page
========================================================================================== -->

<template>
  <div>
    <admin-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
    <vx-card class="overflow-auto">
        <vs-button icon-pack="feather" icon="icon-plus" @click="addNewData">{{$t('ADD_ADMIN')}}</vs-button>
        <v-server-table id="admin-table" ref="adminTable" name="adminTables"
            :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded">
          <vs-chip slot="adminStatus" slot-scope="props" :color="getStatusColor(props.row.admin.adminStatus)" class="w-full">
            {{$t(setStatusName(props.row.admin.adminStatus))}}</vs-chip>
          <div slot="edit" slot-scope="props">
             <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(props.row)" />
          </div>
        </v-server-table>
    </vx-card>
  </div>
</template>

<script>
window.axios = require('axios');

import AdminSidebar from './AdminSidebar.vue'
import moduleAdmin from "@/store/admin/moduleAdmin.js"

export default {
  components: {
    AdminSidebar
  },
  data() {
    return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      // Table
      columns: ['roleName', 'adminId', 'name', 'email', 'adminStatus', 'edit'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['roleName', 'adminId', 'name', 'email',  'adminStatus'],
        sortable: ['roleName', 'adminId', 'name', 'email',  'adminStatus'],
        orderBy: { ascending: true },
        debounce: 1000,
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
            filterBy: this.$t("FILTER_BY"),
            defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'roleName' : () => this.$t("ROLE"),
          'adminId':  () => this.$t("ADMIN_ID"),
          'name':  () => this.$t("ADMIN_NAME"),
          'email':  () => this.$t("EMAIL"),
          'adminStatus':  () => this.$t("ADMIN_STATUS"),
          'edit':  () => this.$t("EDIT"),
        },
        listColumns:{
          adminStatus:[
            {
              id: '1',
              text: this.$t("ACTIVE")
            },
            {
              id: '2',
              text: this.$t("LOCKED")
            },
            {
              id: '3',
              text: this.$t("BLOCKED")
            },
            {
              id: '4',
              text: this.$t("DORMANT")
            }
          ],
          roleName:[
            {
              id: 'admin',
              text: this.$t("admin")
            },
            {
              id: 'user',
              text: this.$t("user")
            },
          ],
        },
        requestAdapter: function(data) {
          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "roleName",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        requestFunction: function (data) {
          return this.$http.get('/api/admin-management/admins', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataAdmin/SET_ADMIN',response.data)
          return {
            data: this.$store.state.dataAdmin.adminUser,
            count: this.$store.state.dataAdmin.count
          }
        },
        templates:{
          roleName: function(h,row){
            return this.$t(row.role.roleName);
          },
          adminId: function(h,row){
            return row.admin.adminId;
          },
          name: function(h,row){
            return row.admin.name;
          },
          email: function(h,row){
            return row.admin.email;
          },
          adminStatus: function(h,row){
            return row.admin.adminStatus;
          }
        }
      }
    }
  },
  created() {
    if (!moduleAdmin.isRegistered) {
      this.$store.registerModule('dataAdmin', moduleAdmin)
      moduleAdmin.isRegistered = true
    }
    this.$store.dispatch("dataAdmin/fetchAdminRole")
    this.$store.dispatch("dataAdmin/fetchAdminStatus")
    this.$store.dispatch("dataAdmin/fetchAdminBlockedReason")
  },
  computed:{

    
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getStatusColor(status) {
      return this.$store.state.commonConfig.adminStatus.properties[status].color
    },
    setStatusName(status){
      return this.$store.state.commonConfig.adminStatus.properties[status].name
    }
  },
}

</script>

<style lang="scss" scoped>
#admin-table{
  text-align:center;
}
</style>